import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router'
import HealtheraTable from '../Table/Table'
import { Flex } from 'reflexbox'
import { HeaderTitle, ColoredText, HealtheraButton } from '../../healtheraComponents'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import HealtheraFooter from '../HealtheraFooter/HealtheraFooter'
import * as actions from '../../redux/organisations'
import * as branchActions from '../../redux/branches'

const BranchesList = props => {

  const { branches = [], organisation: { name: organisationName } = {} } = useSelector(state => state.organisations);
  const { orgID } = useSelector(state => state.authentication);
  const dispatch = useDispatch();

  const organisationID = props.match.params.organisationID;

  useEffect(() => {
    dispatch(actions.getBranches(organisationID))
  }, [dispatch, organisationID])

  const handleSelect = (createNewBranch) => {
    const { history, organisation, organisation: { _id, currentContract: { slots } = {} } = {} } = props
    const slotsRemaining = slots - branches.length
    const message = orgID ? 'Please contact Healthera to add more slots' : 'There are no more slots remaining'

    if (slotsRemaining < 1)
      return alert(message)

    if (createNewBranch) {
      history.push(`${process.env.PUBLIC_URL}/create-new-branch/${_id}`)
    } else {
      history.push(`${process.env.PUBLIC_URL}/branches/create`, { _id, organisation })
    }
  }

  const { organisation: { currentContract: { slots } = {} } = {} } = props
  const prepareData = (branches = []) => {
    return branches.reduce((data, branch) => {
      const {
        _id, pharmacy_name, status, postcode: legacyPostcode, address: { postcode },
        commissionableCount = {}, delivery_partner = {}, paid_delivery = {}, otc_enabled
      } = branch;
      const referralColor = ['premium', 'free'].includes(status) ? '#2f9d6d' : '#c2c2c2';
      const ReferralIndicator = delivery_partner?.rx_referral_commission ? CheckIcon : CloseIcon;
      const PaidDeliveryIndicator = paid_delivery.active ? CheckIcon : CloseIcon;
      const OtcIndicator = otc_enabled ? CheckIcon : CloseIcon;
      data.push({
        view: {
          name: pharmacy_name || '',
          postcode: postcode || legacyPostcode || '',
          active: ['premium', 'free'].includes(status) ? <ColoredText color='#2f9d6d'>Active</ColoredText> : 'Inactive',
          referral: <ReferralIndicator fontSize={'large'} nativeColor={referralColor} />,
          paidDelivery: <PaidDeliveryIndicator fontSize={'large'} nativeColor={referralColor} />,
          cpn: commissionableCount,
          otcEnabled: <OtcIndicator fontSize='large' nativeColor={referralColor} />
        },
        ID: _id,
        button: {
          title: 'Remove', onClick: async (e) => {
            e.stopPropagation()
            if (window.confirm(`Are you sure you want to remove ${branch.pharmacy_name} from ${organisationName}? `)) {
              await dispatch(branchActions.updateBranch(_id, { ...branch, organisationID: null, chain_id: null, chain_name: null }));
              await dispatch(actions.getBranches(organisationID));
              dispatch(actions.getOrganisationCountsByType({}));
            }
          }
        },
        route: 'branches'
      })

      return data;
    }, [{
      view: {
        name: 'Pharmacy Name',
        postcode: 'Post Code',
        active: 'Status',
        referral: 'Referral',
        paidDelivery: 'Paid Delivery',
        cpn: 'Commissionable Patients',
        otcEnabled: 'E-Commerce'
      },
      headers: true
    }]);
  }

  return (
    <>
      {slots && (
        <Flex p={2} align="center">
          <HeaderTitle width={`160px`}>Total Slots: {slots && <span>{slots}</span>}</HeaderTitle>
          <HeaderTitle padding={`0 0 0 26px`} borderleft={`1px #E4E3E3 solid`} width={`250px`}>
            Remaining Slots: {slots && <span>{slots - branches.length}</span>}
          </HeaderTitle>
        </Flex>
      )}
      <HealtheraButton onClick={() => handleSelect(true)}>Create a Pharmacy</HealtheraButton>
      <HealtheraTable data={prepareData(branches)} />
      {orgID && <HealtheraFooter />}
    </>
  );
}

export default withRouter(BranchesList)
